import React from "react";
import { Select, Form } from "antd";
import { getDataSource } from "../../constants/utils";
import { canCorrectField } from "../../utils/fields";
import { Utilitaries } from "../../../../business";

const { Option } = Select;

const getValueKeyName = (field) => {
    for (const key in field) {
        if (typeof field[key] === "object" && key !== "dataSource" && key !== "value") {
            for (const innerKey in field[key]) {
                if (typeof field[key][innerKey] === "object") {
                    return innerKey;
                }
            }
        }
    }
};

const getPath = (field) => {
    for (const key in field) {
        if (typeof field[key] === "object" && key !== "dataSource" && key !== "value") {
            for (const innerKey in field[key]) {
                if (typeof field[key][innerKey] === "object") {
                    return [key, innerKey];
                }
            }
        }
    }
};

const getValue = (valueItem, innerKey) => {
    if (!valueItem.value) {
        return [];
    } else {
        let values = valueItem.value[innerKey] || valueItem.value;
        const valueKeyName = getValueKeyName(valueItem);
        if (Array.isArray(values) && values.length > 1) {
            if (typeof values[0] === "object") {
                return values.map((item) => item[valueKeyName]);
            } else {
                return values;
            }
        } else if (Array.isArray(values) && values.length === 1) {
            if (typeof values[0] === "object") {
                return [values[valueKeyName] || values[0][valueKeyName]];
            } else {
                return values;
            }
        } else if (typeof values === "object" && !Array.isArray(values)) {
            return [values[valueKeyName]];
        } else {
            return [];
        }
    }
};

export const QaFixedList = ({
    root,
    dataSource,
    itemData,
    label,
    formItemStyle,
    rowKey,
    currentTaskStatus,
    handleSelectChange,
    correctForm,
    renderContext,
    showFieldEditorModal,
    error,
}) => {
    const childRootKey = Object.keys(itemData).find((item) => typeof itemData[item] === "object");
    const innerChildPath = getPath(itemData);
    let innerChild;
    let value;
    if (Array.isArray(innerChildPath)) {
        innerChild = itemData[innerChildPath[0]][innerChildPath[1]];
        value = getValue(itemData, innerChildPath[0]);
    }

    if (!dataSource || dataSource.length === 0) {
        dataSource = getDataSource(innerChild);
    }

    const canEdit = canCorrectField(itemData) && correctForm;

    const disabled = canEdit ? false : currentTaskStatus;

    const selectStyle = renderContext === "column" ? { width: showFieldEditorModal ? 150 : "100%" } : { width: "100%" };

    debugger;
    return (
        <Form.Item label={label} style={formItemStyle}>
            <Select
                allowClear
                disabled={disabled}
                value={value}
                onChange={(value) => {
                    if (Array.isArray(innerChildPath) && innerChildPath.length === 2) {
                        const tableSecondKey = innerChildPath[0];
                        const deeperKey = innerChildPath[1];

                        const initialDataValues = Utilitaries.toArray(itemData.value?.[tableSecondKey]);
                        const newValue = {
                            [tableSecondKey]: value.map((item) => {
                                const findInitialValue = initialDataValues.find(
                                    (initialItem) => initialItem[deeperKey] === item
                                );
                                if (findInitialValue) {
                                    return {
                                        ...findInitialValue,
                                        [deeperKey]: item,
                                    };
                                }

                                return {
                                    [deeperKey]: item,
                                };
                            }),
                        };
                        handleSelectChange({
                            value: newValue,
                            key: itemData.key,
                            root,
                            rowKey,
                            childRootKey,
                            inputGroupPath: itemData.inputGroupPath,
                        });
                    }
                }}
                mode="multiple"
                style={selectStyle}
                placeholder={itemData["@placeholder"]}
                filterOption={(input, option) => option?.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
                {dataSource.map((item) => {
                    const optionValue = String(item[innerChild?.["@valor_lista"] || "value"]);
                    return (
                        <Option key={item[innerChild?.["@chave_lista"] || "key"]} title={optionValue}>
                            {optionValue}
                        </Option>
                    );
                })}
            </Select>
            {error && <span style={{ color: "red" }}>{error}</span>}
        </Form.Item>
    );
};
